import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const LoginFormDefaultProps = {
  ...ClassNameDefaultProps,
  company: null,
  errorsIcon: null,
  onForgotPassword: null,
  onSubmit: () => {},
  onSuccess: () => {},
  registerLink: null,
  title: '',
  warehouse: null,
};

export const LoginFormPropTypes = {
  ...ClassNamePropTypes,
  company: PropTypes.string,
  errorsIcon: PropTypes.element,
  onForgotPassword: PropTypes.func,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
  registerLink: PropTypes.string,
  title: PropTypes.string,
  warehouse: PropTypes.string,
};
